import type { ReactNode } from "react";

import { SectionLayout } from "../../components/SectionLayout";

type DependenciesSectionLayoutProps = {
  children?: ReactNode;
};

export function DependenciesSectionLayout({
  children,
}: DependenciesSectionLayoutProps) {
  // The page title is set by DependencyGraphPage itself (this layout's only
  // child, here and everywhere else it's mounted), so it isn't set here to
  // avoid a duplicated "Dependency graph · Dependency graph · ..." title.
  return <SectionLayout>{children}</SectionLayout>;
}
